import React from "react";
import styles from "./style.module.css";

export default function EventCashback() {
  return (
    <div className={styles.wrap}>
      <img
        src="/images/wedding_hall_cashback.png"
        alt="cashback"
        style={{ width: "100%" }}
      />
    </div>
  );
}
